import axios, { AxiosResponse } from 'axios'
import { ID, Response } from 'src/_metronic/helpers'
import { configuration } from 'src/configuration'

const API_URL = configuration.apiUrl
const DeletedTransactions_URL = `${API_URL}/message/v1/transactions`
const City_URL = `${API_URL}/cities`
const PARTY_URL = `${API_URL}/party`
const PARTY_URLS = `${API_URL}/party/getPartyListing`
const USER_URL = `${API_URL}/users/allUser`
const formatDate = (dateStr: string): string => {
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
};

const getDeletedTransactions = async (query: string): Promise<any> => {
  const params = new URLSearchParams(query);
  params.set("isDeleted", "true");
  params.set("isDeletedList", "true");

  const sort = params.get("sort");
  const order = params.get("order")?.toUpperCase();

  params.delete("sort");
  params.delete("order");
  if (sort && order) {
    params.set("orderBy", `${sort} ${order}`);
  }

  const page = params.get("page") || "1";
  const perPage = params.get("perPage") || "10";

  params.set("offset", page);
  params.set("limit", perPage);

  return axios
    .get(`${DeletedTransactions_URL}?${params.toString()}`)
    .then((res: AxiosResponse<any>) => {
      console.log("newlog",res);
      
      const formattedData = res.data?.responseData
      ?.map((item: any) => {
        if (item?.created_date) {
          const date = item.created_date.split("T")[0]; // Remove time part
          item.created_date = formatDate(date);
        }
        return item;
      });

      return {
        ...res.data,
        data: formattedData,
      };
    });
};


const getTransaction = (query: string): Promise<any> => {
  return axios
    .get(`${PARTY_URL}?is_active=true&sort=party_name&order=ASC`)
    .then((d: AxiosResponse<any>) => d.data)
}

const getUsers = (query: string): Promise<any> => {
  return axios.get(`${USER_URL}?sort=name&order=ASC`).then((d: AxiosResponse<any>) => d.data)
}
const uniqueCode = (query: string): Promise<any> => {
  return axios
    .get(`${DeletedTransactions_URL}/uniqueCode?party_code=${query}`)
    .then((d: AxiosResponse<any>) => d.data)
}
const getCities = (): Promise<any> => {
  return axios.get(`${City_URL}?sort=name&order=ASC`).then((d: AxiosResponse<any>) => d.data)
}
const getDeletedTransactionsById = (id: any): Promise<any> => {
  return axios
    .get(`${DeletedTransactions_URL}/${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const createDeletedTransactions = (data: any): Promise<any> => {
  return axios
    .post(DeletedTransactions_URL, data)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const createCity = (data: any): Promise<any> => {
  return axios.post(City_URL, data).then((response: AxiosResponse<Response<any>>) => response.data)
}

const updateDeletedTransactions = (data: any, id: any): Promise<any> => {
  return axios
    .patch(`${DeletedTransactions_URL}/${id}`, data)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const deleteDeletedTransactions = (id: any): Promise<any> => {
  return axios
    .delete(`${DeletedTransactions_URL}/${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const DeviceTokenReset = (id: any): Promise<any> => {
  return axios
    .delete(`${DeletedTransactions_URL}/deviceTokenReset/${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const deleteSelectedDeletedTransactions = (DeletedTransactionsIds: Array<ID>): Promise<void> => {
  const requests = DeletedTransactionsIds.map((id) => axios.delete(`${DeletedTransactions_URL}/${id}`))
  return axios.all(requests).then(() => { })
}

const getParties = (): Promise<any> => {
  return axios
    .get(`${PARTY_URLS}?is_active=true&sort=party_name&order=ASC`)
    .then((d: AxiosResponse<any>) => d.data)
}

export {
  createDeletedTransactions,
  deleteDeletedTransactions,
  deleteSelectedDeletedTransactions,
  getDeletedTransactionsById,
  getDeletedTransactions,
  updateDeletedTransactions,
  getTransaction,
  createCity,
  getCities,
  DeviceTokenReset,
  uniqueCode,
  getUsers,
  getParties
}
